import { Skeleton } from '@/components/ui';

const SKELETON_ROWS = 12;
const SKELETON_COLS = 7;

function FooterSpinner() {
  return (
    <svg className="bulk-import__footer-spinner" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5" strokeOpacity="0.25" />
      <path d="M14 8a6 6 0 00-6-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

interface BulkImportTableSkeletonProps {
  /** Real footer action shown during credential issue (spinner + label). */
  footerAction?: { label: string; loading?: boolean };
}

export function BulkImportTableSkeleton({ footerAction }: BulkImportTableSkeletonProps = {}) {
  return (
    <div className="bulk-import__skeleton" aria-busy="true" aria-label="Loading user data">
      <div className="bulk-import__skeleton-header">
        <Skeleton className="bulk-import__skeleton-title" />
        <Skeleton className="bulk-import__skeleton-subtitle" />
        <div className="bulk-import__skeleton-header-actions">
          <Skeleton className="bulk-import__skeleton-btn" />
          <Skeleton className="bulk-import__skeleton-btn" />
        </div>
      </div>

      <div className="bulk-import__skeleton-toolbar">
        <Skeleton className="bulk-import__skeleton-search" />
        <Skeleton className="bulk-import__skeleton-filter" />
        <Skeleton className="bulk-import__skeleton-filter" />
      </div>

      <div className="bulk-import__skeleton-table">
        <div className="bulk-import__skeleton-table-head">
          {Array.from({ length: SKELETON_COLS }).map((_, i) => (
            <Skeleton key={`head-${i}`} className="bulk-import__skeleton-cell" />
          ))}
        </div>
        {Array.from({ length: SKELETON_ROWS }).map((_, row) => (
          <div key={`row-${row}`} className="bulk-import__skeleton-table-row">
            {Array.from({ length: SKELETON_COLS }).map((_, col) => (
              <Skeleton key={`cell-${row}-${col}`} className="bulk-import__skeleton-cell" />
            ))}
          </div>
        ))}
      </div>

      <div className="bulk-import__skeleton-footer">
        {footerAction ? (
          <button
            type="button"
            className={`bulk-import__approve-btn bulk-import__skeleton-footer-action${footerAction.loading ? ' bulk-import__approve-btn--loading' : ''}`}
            disabled
          >
            {footerAction.loading ? <FooterSpinner /> : null}
            {footerAction.label}
          </button>
        ) : (
          <Skeleton className="bulk-import__skeleton-footer-btn" />
        )}
      </div>
    </div>
  );
}
